<script setup>
import { computed } from 'vue';
import { t } from '../i18n';

// Live price indicator in the phone header (docs/design/SPEC.md, decision 8): a filled green dot while
// prices update, an empty amber ring when they don't. The shapes differ, so it reads without colour too.
const props = defineProps({
  // 'on' | 'off' | null (no answer yet: nothing is shown)
  state: {
    type: String,
    default: null,
  },
  time: {
    type: String,
    default: '',
  },
});

defineEmits(['open']);

const label = computed(() => (props.state === 'on' ? t('live.on', { time: props.time }) : t('live.off')));
</script>

<template>
  <button
    v-if="state"
    type="button"
    class="flex size-11 items-center justify-center rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400"
    :aria-label="label"
    aria-haspopup="dialog"
    @click="$emit('open')"
  >
    <span
      class="size-2.5 rounded-full"
      :class="state === 'on' ? 'bg-emerald-400' : 'border-2 border-amber-400'"
      aria-hidden="true"
    />
  </button>
</template>
